<template>
  <div class="ca-footer__quick-access mx-size-0 my-size-5">
    <div
      class="ca-footer__quick-access-row gap-size-4"
      :style="{ '--quick-link-count': links.length }"
    >
      <CaBaseButton
        v-for="(item, idx) in links"
        :key="idx"
        :label="item.label"
        type="inverted"
        variant="tertiary"
        class="ca-footer__quick-link ca-base-button"
        @click="navigateTo(item.url)"
      >
        <template #trailingIcon>
          <img
            v-if="item.icon"
            :src="item.icon"
            :alt="item.label"
            class="ca-footer__quick-link-icon"
          />
        </template>
      </CaBaseButton>
    </div>
  </div>
</template>

<script setup>
import CaBaseButton from "../../base/buttons/CaBaseButton.vue";

defineProps({
  links: {
    type: Array,
    required: true,
  },
});

function navigateTo(url) {
  window.location.href = url;
}
</script>

<style scoped lang="scss">
.ca-footer__quick-access-row {
  display: flex;
  flex-direction: column;

  @include ca-bp("sm") {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: var(--size-4);
  }

  @media (min-width: 1025px) {
    grid-template-columns: repeat(var(--quick-link-count, 5), 1fr);
    gap: var(--size-5);
  }
}

.ca-footer__quick-link.ca-base-button {
  width: 100%;
  justify-content: flex-start;
  gap: var(--size-3);
  background-color: var(--ca-color-neutrals-inverted-10);
  border: none;
  border-radius: 8px;
  padding: 0 var(--size-5) 0 var(--size-5);
  color: var(--ca-color-text-inverted);

  @media (min-width: 1025px) {
    padding-left: 16px;
  }
}

.ca-footer__quick-link-icon {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  object-fit: contain;
}
</style>
